var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[(_vm.isLoading)?_c('b-col',[_c('Loader',{attrs:{"size":"md"}})],1):_c('b-col',[(_vm.item)?_c('EXCMAgreementSlaForm',{attrs:{"type":2,"handle-submit":_vm.onSendForm,"handle-update-field":_vm.updateField,"values":_vm.item,"errors":_vm.violations,"initial-values":_vm.retrieved}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }